export class UserNode {
    id: number;
    username: String;
    firstName: String;
    lastName: String;
    team: number;
    site: number;
    periods: Array<any>;
    villeLabel: string;
    assignement: string;
}



// WEBPACK FOOTER //
// ./src/app/model/user-node.ts